import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { AssetTabMaintenanceCostsDataGrid } from '../../../components/datagrid/AssetTabMaintenanceCostsDataGrid';
import { CONFIG_KEYS, useConfigByKey } from '../../../contexts/configContext';
import { PageContentWrapper } from '../../../layouts/contentWrapper/PageContentWrapper';
import { MaintenanceCost, MaintenanceCostType } from '../../../types/maintenanceCost.types';
import { DetailPageParams } from '../../../types/pageParams.types';
import { API_URL, fetcher } from '../../../utils/apiUrl';
import { assetEditSwrConfig, ITab, swrConfig } from '../AssetsEdit';

interface Props extends ITab {
  isReadonly: boolean;
  onCostCountChange?: () => void;
}

/**
 * Záložka s evidencí nákladů na údržbu stroje (#737).
 * Zobrazuje se jen při aktivním modulu, editace vyžaduje WfAssetEdit.
 */
export function AssetTabMaintenanceCosts({ active, isReadonly, onCostCountChange }: Props) {
  const { id } = useParams<DetailPageParams>();
  // měna je společná pro celou aplikaci, do záznamu se neukládá
  const currencyConfig = useConfigByKey(CONFIG_KEYS.MAINTENANCE_COST_CURRENCY);

  const {
    data: costs,
    error: errorCosts,
    mutate: mutateCosts,
    isValidating: costsIsValidating,
  } = useSWR<MaintenanceCost[]>(
    id ? `${API_URL.MAINTENANCE_COST_LIST}?parentId=${id}` : null,
    fetcher,
    assetEditSwrConfig,
  );

  // číselník druhů nákladů - swrConfig (ne assetEditSwrConfig), ať se načte hned při mountu
  const { data: costTypes, error: errorCostTypes } = useSWR<MaintenanceCostType[]>(
    `${API_URL.MAINTENANCE_COST_TYPE_LIST}`,
    fetcher,
    swrConfig,
  );

  useEffect(() => {
    if (active) mutateCosts();
  }, [active]);

  const handleDataChanged = () => {
    mutateCosts();
    if (onCostCountChange) onCostCountChange();
  };

  return (
    <PageContentWrapper
      noContentBlock
      noDxCard
      error={errorCosts || errorCostTypes}
      loading={costsIsValidating}
    >
      <AssetTabMaintenanceCostsDataGrid
        assetId={Number(id)}
        data={costs}
        costTypes={costTypes}
        currency={currencyConfig?.value}
        isReadOnly={isReadonly}
        mutateData={handleDataChanged}
      />
    </PageContentWrapper>
  );
}
